export const SPONSORINFO_IMAGE_DERIVATIVE_WIDTHS = [215, 430, 645];
export const SPONSORINFO_IMAGE_SIZE = ["215px"];
